import * as z from "zod";
import { userFacingError } from "../authorization";
import { zql } from "../generatedDrizzleSchema";
import { mutator } from "./mutator";

export const deleteRole = mutator({
  schema: z.object({
    roleId: z.string(),
  }),
  resolve: {
    role: { kind: "role", from: "roleId" },
  },
  permissions: [
    { permission: "tenant:roles_manage", scopeId: ({ ctx }) => ctx.tenantId },
  ],
  fn: async ({ tx, args: { role } }) => {
    const grants = await tx.run(zql.roleGrants.where("customRoleId", role.id));
    if (grants.length > 0) {
      throw userFacingError("Cannot delete a role that is still assigned");
    }
    await tx.mutate.roles.delete({ id: role.id });
  },
});
